import DefaultValidation from "@/services/validations/DefaultValidation";
import Message from '@/models/Message';

export default class ConfigurarRecibosValidation extends DefaultValidation{

  constructor(msgs) {
    super(msgs);
  }

  validate(model, refs) {
    let validated = true;

    Object.entries(model).forEach(([key, value]) => {
      if(value!=null && typeof value == "string") model[key] = value.trim();
    });

    if (!model.titulo || !model.texto || model.texto=='') {
      refs.tituloInput.focusedOut = true;
      refs.textoInput.focusedOut = true;
      validated = false;
      this.showMessage(new Message("alert", 'msg-campos-obrigatorios', true));
    }
    
    return validated;
  }

}